// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"793":"f8648d46","822":"d57b639e","878":"49a528ea"}[chunkId] + ".css";
};